import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import CatalogoInmueble from "../../catalogos/catalogoInmueble";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";
import { DangerButton, InfoButton } from "../../ui/buttons/Button";

const ImpCedulaCatastral = (props) => {
  let op = require("../../../src/modulos/datos");
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  let token = localStorage.getItem("jwtToken");
  const btnCancela = useRef();
  const txtNumero = useRef();
  const txtCod = useRef();
  const txtNFicha = useRef();
  const txtNInscrip = useRef();
  const txtCodCat = useRef();
  const txtCodCatAnt = useRef();
  const txtDirecInm = useRef();
  const txtCedPropi = useRef();
  const txtNomPropi = useRef();
  const txtDirecPropi = useRef();
  const txtNorte = useRef();
  const txtEste = useRef();
  const txtSur = useRef();
  const txtOeste = useRef();
  const [configCatastro, setConfigCatastro] = useState();
  const [detalle, setDetalle] = useState();
  const [nota, setNota] = useState();
  const [inmueble, setInmueble] = useState();
  const [dataUsuario, setDataUsuario] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [tipo, setTipo] = useState("0");
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [tiporep] = useState();
  const blanquear = () => {
    setTipo("");
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.render(props.idAval);
    props.setShow();
  };
  const cancelar = () => {
    blanquear();
    props.setShow();
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    let sigue = true;
    if (txtCod.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un inmueble",
        icono: "informacion",
      });
      sigue = false;
      txtCod.current.focus();
    }
    console.log('Tipo:', tipo, 'espíritu:', espiritu);
    if (sigue) {
      if (parseInt(tipo) === 1) {

        if (parseInt(inmueble.status) === 61) {
          let sql = txtCod.current.value;
          let fileName2 = "";
          // Eliminamos la variable archivo y fichero ya que no se usarán
          // let archivo = inmueble.codigocatastral
          //   ? inmueble.codigocatastral.substring(0, 18) + ".jpg"
          //   : "";
          // let fichero = `${op.imagenreportes}/imagen?img=${archivo}`;
          
          let titulo =
            parseInt(tipo) === 1 ? "CEDULA CATASTRAL" : "CERTIFICADO DE EMPADRONAMIENTO";
          let nomela = dataUsuario ? dataUsuario.nombres : "";
          let cedela = dataUsuario ? dataUsuario.persona : "";
          let nombredir = configCatastro ? configCatastro.nombre.trim() : "";
          let ceduladir = configCatastro ? configCatastro.cedula.trim() : "";
          let civ = configCatastro
            ? configCatastro.civ
              ? configCatastro.civ.trim()
              : ""
            : "";
          let resolucion = configCatastro
            ? configCatastro.resolucion.trim()
            : "";
          let cargo = configCatastro ? configCatastro.cargo.trim() : "";
          let valida =
            configCatastro && configCatastro.validopor
              ? configCatastro.validopor.trim()
              : "";

          // Eliminamos toda la lógica de axios que verificaba la imagen
          // y abrimos directamente el reporte correspondiente
          
          if (
            parseInt(espiritu) === 9 ||
            (parseInt(espiritu) === 15 &&
              txtCedPropi.current.value.length > 13) ||
            (parseInt(espiritu) === 15 && txtNomPropi.current.value.length > 60)
          ) {
            // CASO 1: espíritu 9, 15 con ciertas condiciones
            if (parseInt(espiritu) === 15) {
              window.open(
                `${
                  op.reportes + "/catastro?"
                }reporte=ForFichaCatastroPlanoG&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                  txtDirecInm.current.value
                }&DIRPRO= ${
                  txtDirecPropi.current.value
                }&numero=39&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
              );
            } else {
              fileName2 = "ForFichaCatastroPaez";
              window.open(
                `${
                  op.reportes + "/catastro?"
                }reporte=ForFichaCatastroPaez&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                  txtDirecInm.current.value
                }&DIRPRO= ${
                  txtDirecPropi.current.value
                }&numero=39&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
              );
            }
          } else if (parseInt(espiritu) === 9 || parseInt(espiritu) === 15) {
            // CASO 2: espíritu 9 o 15 sin las condiciones anteriores
            if (parseInt(espiritu) === 15) {
              fileName2 = "ForFichaCatastroPlanoG";
              window.open(
                `${
                  op.reportes + "/catastro?"
                }reporte=ForFichaCatastroPlanoG&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                  txtDirecInm.current.value
                }&DIRPRO= ${
                  txtDirecPropi.current.value
                }&numero=39&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
              );
            } else {
              fileName2 = "ForFichaCatastroPlano";
              window.open(
                `${
                  op.reportes + "/catastro?"
                }reporte=ForFichaCatastroPlano&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                  txtDirecInm.current.value
                }&DIRPRO= ${
                  txtDirecPropi.current.value
                }&numero=39&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
                "Planilla",
                "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
              );
            }
          } else if (parseInt(espiritu) === 0 || parseInt(espiritu) === 1 || parseInt(espiritu) === 14) {
            // CASO 3: espíritu 0 o 1
            fileName2 = "ForFichaCatastroPaez";
            window.open(
              `${
                op.reportes + "/catastro?"
              }reporte=ForFichaCatastroPaez&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                txtDirecInm.current.value
              }&DIRPRO= ${
                txtDirecPropi.current.value
              }&numero=39&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          }
        }
      } else if (parseInt(tipo) === 2) {
        // ... (código para tipo 2 se mantiene igual)
        if (parseInt(inmueble.status) === 61) {
          let sql = txtCod.current.value;
          let titulo =
            parseInt(tipo) === 1 ? "CEDULA CATASTRAL" : "CERTIFICADO DE EMPADRONAMIENTO";
          let nomela = dataUsuario ? dataUsuario.nombres : "";
          let cedela = dataUsuario ? dataUsuario.persona : "";
          let nombredir = configCatastro ? configCatastro.nombre.trim() : "";
          let ceduladir = configCatastro ? configCatastro.cedula.trim() : "";
          let civ = configCatastro
            ? configCatastro.civ
              ? configCatastro.civ.trim()
              : ""
            : "";
          let resolucion = configCatastro
            ? configCatastro.resolucion.trim()
            : "";
          let cargo = configCatastro ? configCatastro.cargo.trim() : "";
          let valida = configCatastro ? configCatastro.validopor.trim() : "";
          console.log(espiritu);
          
          if (
            parseInt(espiritu) === 9 ||
            parseInt(espiritu) === 12 ||
            parseInt(espiritu) === 15
          ) {
            window.open(
              `${
                op.reportes + "/catastro?"
              }reporte=ForFichaCatastro1&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                txtDirecInm.current.value
              }&DIRPRO= ${
                txtDirecPropi.current.value
              }&numero=40&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else if (parseInt(espiritu) === 100) {
            window.open(
              `${
                op.reportes + "/catastro?"
              }reporte=ForFichaCatastroEmpa&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                txtDirecInm.current.value
              }&DIRPRO= ${
                txtDirecPropi.current.value
              }&numero=40&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else {
            window.open(
              `${
                op.reportes + "/catastro?"
              }reporte=ForFichaCatastroEmpadro&inmueble=${sql}&TITULO=${titulo}&DIRINMU=${
                txtDirecInm.current.value
              }&DIRPRO= ${
                txtDirecPropi.current.value
              }&numero=40&NOMELA=${nomela}&CEDELA=${cedela}&NOMBREDIR=${nombredir}&CEDULADIR=${ceduladir}&CIV=${civ}&RESOLUCION=${resolucion}&CARGO=${cargo}&VALIDOPOR=${valida}&ESPIRITU=${espiritu}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          }
        }
      }
    }
  };
  function maskIt(pattern, value) {
    let position = 0;
    let currentChar = 0;
    let masked = "";
    while (position < pattern.length && currentChar < value.length) {
      if (pattern[position] === "0") {
        masked += value[currentChar];
        currentChar++;
      } else {
        masked += pattern[position];
      }
      position++;
    }
    return masked;
  }

  const seleccionar_usuario = (id) => {
    let endpoint = `${op.conexion}/api/catastro/datausuario?idusuario=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setDataUsuario(response.data[0]);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
        
        let errorMessage = "Error al obtener datos del usuario";
        if (error.response) {
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.request) {
          errorMessage = "No se recibió respuesta del servidor";
        } else {
          errorMessage = error.message || errorMessage;
        }
  
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: errorMessage,
          icono: "error",
        });
      });
  };

  const seleccionarEstatus = () => {
    let endpoint = `${op.conexion}/api/catastro/selectid`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            // Procesar datos si es necesario
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setActivate(false);
        
        // Manejo más seguro del error
        let errorMessage = "Ocurrió un error al obtener el estatus";
        
        if (error.response) {
          // El servidor respondió con un código de estado fuera del rango 2xx
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.request) {
          // La solicitud fue hecha pero no se recibió respuesta
          errorMessage = "No se recibió respuesta del servidor";
        } else {
          // Algo pasó al configurar la solicitud
          errorMessage = error.message || errorMessage;
        }
  
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: errorMessage,
          icono: "error",
        });
      });
  };

  const actualizar = () => {
    let endpoint = `${op.conexion}/api/catastro/actualizaravaluo`;
    let body;
    setActivate(true);
    body = {
      operacion: 1,
      idconstancia: 0,
      idinmue: txtCod.current.value,
      cnumficha: txtNFicha.current.value,
      cnuminscri: txtNInscrip.current.value,
      ccodigoant: txtCodCatAnt.current.value.replace("-", ""),
      ccodigocat: txtCodCat.current.value.replace("-", ""),
      cdirinmue: txtDirecInm.current.value,
      cnombreo: inmueble.nombreocupante,
      ccedulao: inmueble.cedulaocupante,
      cnombrep: inmueble.nombrepropie,
      ccedulap: inmueble.cedulapropie,
      cregpropie: inmueble.regpropieterreno,
      nareaterre: inmueble.areaterreno,
      nareaterred: detalle.areaterreno,
      nareamuni: inmueble.areamunicipal,
      nvalorterre: inmueble.valorterreno,
      nareaconstru: inmueble.areaconstruccion,
      nareaconstrud: detalle.areaconstruccion,
      nvalorconstru: inmueble.valorconstruccion,
      clinderon: txtNorte.current.value,
      clinderos: txtSur.current.value,
      clinderoe: txtEste.current.value,
      clinderoo: txtOeste.current.value,
      cnotaconsta: nota,
      cnumeroreg: detalle.numeroregistro,
      cfolio: detalle.folio,
      ctomo: detalle.tomo,
      cprotocolo: detalle.protocolo,
      fechareg: detalle.fecharegistro,
      ntipoconst: tiporep,
      dfechaconsta: fechasistema,
      nrural: detalle.rural,
      cobser: inmueble.obserterreno,
      cusoterre: inmueble.usoterreno !== null ? inmueble.usoterreno : "",
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const nrocedula2 = () => {
    let endpoint = `${op.conexion}/api/catastro/nrocedula2?anio=${anioactu}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let nrocedula = 0;
          if (response.data !== "") {
            nrocedula = response.data.nrocedula
              ? parseInt(response.data.nrocedula) + 1
              : 0 + 1;
            txtNumero.current.value = nrocedula;
          } else {
            txtNumero.current.value = 1;
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const nrocertificado2 = () => {
    let endpoint = `${op.conexion}/api/catastro/nrocertificado2?anio=${anioactu}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let nrocedula = 0;
          if (response.data.nrocertificado) {
            nrocedula = response.data.nrocertificado
              ? parseInt(response.data.nrocertificado) + 1
              : 0 + 1;
            txtNumero.current.value = nrocedula;
          } else {
            txtNumero.current.value = 1;
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const nrocedula = (id) => {
    let endpoint = `${op.conexion}/api/catastro/nrocedula?idinmueble=${id}&anio=${anioactu}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.nrocedula) {
            txtNumero.current.value = response.data.nrocedula;
          } else {
            nrocedula2();
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const nrocertificado = (id) => {
    let endpoint = `${op.conexion}/api/catastro/nrocertificado?idinmueble=${id}&anio=${anioactu}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.nrocertificado) {
            txtNumero.current.value = response.data.nrocertificado;
          } else {
            nrocertificado2();
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleecionar_director = () => {
    let endpoint = `${op.conexion}/api/catastro/configcatastro`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setConfigCatastro(response.data);
        }
        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
        
        let errorMessage = "Error al obtener datos del director";
        if (error.response) {
          // El servidor respondió con un error
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.request) {
          // La solicitud fue hecha pero no hubo respuesta
          errorMessage = "No se recibió respuesta del servidor";
        } else {
          // Error al configurar la solicitud
          errorMessage = error.message || errorMessage;
        }
  
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: errorMessage,
          icono: "error",
        });
      });
  };

  const seleccionarDetalleRegistro = (data) => {
    let endpoint = `${op.conexion}/api/catastro/detalle?idinmueble=${data.idinmueble}&idvalorterreno=${data.idvalorterreno}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setDetalle(response.data);
            setActivate(false);
          } else {
            setActivate(false);
          }
        }
      })
      .catch(() => {
        setMensaje({
          mostrar: true,
          titulo: "MENSAJE",
          texto: "No posee Valor de terreno.",
          icono: "informacion",
        });
        setActivate(false);
      });
  };

  const datosClasificador = (id) => {
    setMostrarCatalogo(false);
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setInmueble(response.data);
            seleccionarDetalleRegistro(response.data);
            if (tipo === 1) {
              nrocedula(response.data.idinmueble);
            } else {
              nrocertificado(response.data.idinmueble);
            }
            txtCod.current.value = response.data.idinmueble;
            txtNFicha.current.value = response.data.numficha;
            txtNInscrip.current.value = response.data.numinscripcion;
            txtCodCat.current.value = maskIt(
              "00-00-00-0-00-000-000-000-000-000-000",
              response.data.codigocatastral.replace("-", "")
            );
            txtCodCatAnt.current.value = maskIt(
              "00-00-00-00-00-00-00-00-000",
              response.data.codigoanterior.replace("-", "")
            );
            txtDirecInm.current.value =
              response.data.dirinmue1.trim() +
              " " +
              response.data.descridirinmue1.trim() +
              " " +
              response.data.dirinmue2.trim() +
              " " +
              response.data.descridirinmue2.trim() +
              " " +
              response.data.dirinmue5.trim() +
              " " +
              response.data.descridirinmue5.trim() +
              " N° " +
              response.data.numcivicoinmue.trim() +
              " " +
              response.data.parroquia.trim();
            txtCedPropi.current.value = response.data.cedulapropie;
            txtNomPropi.current.value = response.data.nombrepropie;
            txtDirecPropi.current.value =
              response.data.ciudadpropie.trim() +
              " " +
              response.data.dirpropie1.trim() +
              " " +
              response.data.descridirpropie1.trim() +
              " " +
              response.data.dirpropie2.trim() +
              " " +
              response.data.descridirpropie2.trim() +
              " " +
              response.data.dirpropie5.trim() +
              " N° " +
              response.data.numcivicopropie.trim();
            txtNorte.current.value = response.data.linderonorte;
            txtEste.current.value = response.data.linderoeste;
            txtSur.current.value = response.data.linderosur;
            txtOeste.current.value = response.data.linderooeste;
            setActivate(false);
          } else {
            txtCod.current.value = "";
            txtNFicha.current.value = "";
            txtNInscrip.current.value = "";
            txtCodCat.current.value = "";
            txtCodCatAnt.current.value = "";
            txtDirecInm.current.value = "";
            txtCedPropi.current.value = "";
            txtNomPropi.current.value = "";
            txtDirecPropi.current.value = "";
            txtNorte.current.value = "";
            txtEste.current.value = "";
            txtSur.current.value = "";
            txtOeste.current.value = "";
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarClasificador = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosClasificador(event.target.value);
      } else {
        txtCod.current.value = "";
        txtNFicha.current.value = "";
        txtNInscrip.current.value = "";
        txtCodCat.current.value = "";
        txtCodCatAnt.current.value = txtDirecInm.current.value = "";
        txtCedPropi.current.value = "";
        txtNomPropi.current.value = "";
        txtDirecPropi.current.value = "";
        txtNorte.current.value = "";
        txtEste.current.value = "";
        txtSur.current.value = "";
        txtOeste.current.value = "";
      }
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTipo(parseInt(props.operacion));
        setNota("");
        seleecionar_director();
        const idusuario = JSON.parse(localStorage.getItem("idusuario"));
        seleccionar_usuario(idusuario);
        seleccionarEstatus();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {parseInt(tipo) === 1
            ? "Cedula Catastral"
            : "Centificado de Empadronamiento"}
        </h3>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
          <div className="col-3 m-0 mb-2 p-0">
            <Input label = 'Nro de Documento:'
              ref={txtNumero}
              disabled
            />
          </div>
          <div className="col-3 m-0 mb-2 ml-auto p-0">
            <SearchInput label = 'Código:'
              onKeyUp={validarClasificador}
              name="idvalorterreno"
              ref={txtCod}
                onClickButton = {()=> setMostrarCatalogo(true)}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0 d-flex justify-content-end">
            <div className="col-3 m-0 p-0">
                <Input label = 'Ficha Catastral N°:'
                name="idvalorterreno"
                disabled
                ref={txtNFicha}
                />
            </div>
          </div>
          <div className="col-4 m-0 mb-2 p-0">
            <Input label = 'Incripción Catastral N°:'
              name="idvalorterreno"
              disabled
              ref={txtNInscrip}
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input label = 'Cód. Catastral:'
              name="idvalorterreno"
              disabled
              ref={txtCodCat}
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input label = 'Cód. Catastral Anterior:'
              name="idvalorterreno"
              disabled
              ref={txtCodCatAnt}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea label = 'Dirección de Inmueble:'
              style={{ height: 70 }}
              name="idvalorterreno"
              disabled
              ref={txtDirecInm}
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0">
            <Input label = 'Cédula/Rif del Propietario:'
              name="idvalorterreno"
              disabled
              ref={txtCedPropi}
            />
          </div>
          <div className="col-8 m-0 mb-2 p-0 pl-2">
            <Input label = 'Nombre del Propietario:'
              name="idvalorterreno"
              disabled
              ref={txtNomPropi}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea label = 'Dirección del Propietario:'
              style={{ height: 70 }}
              name="idvalorterreno"
              disabled
              ref={txtDirecPropi}
            />
          </div>
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
            <legend className="float-none w-auto m-0">
              Detalle de la Construcción
            </legend>

            <div className="col-6 m-0 mb-2 p-0">
              <Textarea label = 'Norte:'
                style={{ height: 70 }}
                name="idvalorterreno"
                disabled
                ref={txtNorte}
              />
            </div>
            <div className="col-6 m-0 mb-2 p-0 pl-2">
              <Textarea label = 'Este:'
                style={{ height: 70 }}
                name="idvalorterreno"
                disabled
                ref={txtEste}
              />
            </div>
            <div className="col-6 m-0 p-0">
              <Textarea label = 'Sur:'
                style={{ height: 70 }}
                name="idvalorterreno"
                disabled
                ref={txtSur}
              />
            </div>
            <div className="col-6 m-0 p-0 pl-2">
              <Textarea label = 'Oeste:'
                style={{ height: 70 }}
                name="idvalorterreno"
                disabled
                ref={txtOeste}
              />
            </div>
          </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <InfoButton icon = 'fa-print'
          onClick={onChangeValidar}
        >
          Imprimir
        </InfoButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <CatalogoInmueble
        show={mostrarCatalogo}
        onHideAceptaCatInm={datosClasificador}
        onHideCancelaCatInm={() => {
          setMostrarCatalogo(false);
        }}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
export default ImpCedulaCatastral;